// extracted by mini-css-extract-plugin
export default {"palleteContainer":"ColorPallete_palleteContainer__YOjG1","roundColor":"ColorPallete_roundColor__QuL5b"};